import { BasketPlusIcon } from './BasketPlusIcon';

/**
 * author: Michael Irigoyen
 * id 3B02F0C6-F80B-479B-ABA7-CFBDBA843EB4
 * name basket-plus
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-plus.svg
 * tags
 * - Shopping 
 */
export const SkipPlusIcon = BasketPlusIcon;
export default SkipPlusIcon